import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  rootRow: {
    borderBottom: `1px solid ${theme.palette.darkGrey[15]}`,
    padding: '1rem 0',
  },

  headerRow: {
    padding: '1rem 2rem',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },

  labelRow: {
    display: 'flex',
    textAlign: 'start',
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightMedium,
    alignItems: 'center',
    gap: 8,
  },

  iconInitialState: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  iconRotate: {
    transform: 'rotate(180deg)',
  },

  contentRightRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: theme.spacing(1.2),
    '& > :last-child': {
      marginLeft: theme.spacing(3.5),
    },
  },

  tdName: {
    width: '40%',
    fontWeight: theme.typography.fontWeightMedium,
  },
  brandPublishError: {
    color: theme.palette.error.main,
  },

  td: {
    width: '30%',
  },

  publishProvider: {
    display: 'flex',
    alignItems: 'center',
    paddingInline: '12px',
    '& > :first-child': {
      marginRight: theme.spacing(2),
    },
  },
  publishErrorProvider: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: '12px',
    backgroundColor: theme.palette.error.light,
    color: theme.palette.darkGrey.main,
    width: 'max-content',
  },
  viewDetails: {
    cursor: 'pointer',
  },
}));

export default useStyles;
